//系统内置指标样式4：对话编码数据S-T分析
<template>
  <div class="indicator-container">
    <ListHeader title="对话编码数据S-T分析"/>
    <div class="indicator-content">
      <div class="score-box">
        <Score :score="data.score" :max-score="data.maxScore"/>
      </div>
      <div class="divider"></div>
      <div class="text-box">

        {{ data.remark }}
        <!--              教师在整节课中始终围绕“名字里的故事-->
        <!--                ”这一核心教学内容，结合教材意图和课-->
        <!--                后练习要求，设定了清晰、具体、可操作-->
        <!--                的教学目标。例如，在导入阶段-->
        <!--                (00:26-05:12)，教师通过引导学生猜测-->
        <!--                自己的名字由来，激发学生的表达动机，-->
        <!--                并自然过渡到学习如何讲述自己...-->
      </div>
      <div class="divider"></div>
      <div class="chart-box">
        <div class="triangle-chart">
          <TriangleChart :x="rtValue" :y="chValue"/>
        </div>
        <div id="lineChart" class="line-chart-item"></div>
      </div>
    </div>
  </div>
</template>
<script>

import ListHeader from '@/components/ListHeader.vue';
import TriangleChart from '@/components/TriangleChart.vue';
import Score from './Score.vue';
import * as echarts from 'echarts';

export default {
  name: 'SysStyle4',
  components: {
    ListHeader,
    Score,
    TriangleChart,
  },

  props: {
    data: {
      type: Object,
      default: null
    },
  },
  computed: {
    rtValue() {
      return JSON.parse(this.data.extra).st_analysis_metrics.rt_value;
    },
    chValue() {
      return JSON.parse(this.data.extra).st_analysis_metrics.ch_value;
    }
  },
  mounted() {
    // 页面挂载后初始化折线图
    this.initLineChart();

    // 监听窗口大小变化，重新调整图表大小
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    window.removeEventListener('resize', this.handleResize);

    // 销毁图表实例，避免内存泄漏
    if (this.lineChart) {
      this.lineChart.dispose();
    }
  },
  methods: {
    // 初始化折线图
    initLineChart() {
      this.lineChart = echarts.init(document.getElementById('lineChart'));
      this.renderLineChart();
    },

    // 渲染折线图
    renderLineChart() {
      // Mock数据：S-T分析的时间序列数据
      const extra = JSON.parse(this.data.extra).code_type_nums;
      const mockData = {
        categories: Object.keys(extra),
        teacherActivity: Object.values(extra), // 教师活动比例
      };

      const option = {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['师生互动'],
          textStyle: {
            color: '#7BA8D0'
          },
          top: 10
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          top: '40px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: mockData.categories,
            axisLine: {
              lineStyle: {
                color: '#043B6A'
              }
            },
            axisLabel: {
              color: '#7BA8D0',
              fontSize: 12
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#043B6A'
              }
            },
            axisLabel: {
              color: '#7BA8D0',
              fontSize: 12,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(4, 59, 106, 0.3)'
              }
            }
          }
        ],
        series: [
          {
            name: '师生互动',
            type: 'line',
            stack: '总量',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: 'rgba(5, 133, 247, 0.6)'},
                {offset: 1, color: 'rgba(5, 133, 247, 0.1)'}
              ])
            },
            emphasis: {
              focus: 'series'
            },
            lineStyle: {
              color: '#0585F7',
              width: 2
            },
            itemStyle: {
              color: '#0585F7'
            },
            data: mockData.teacherActivity
          },
        ]
      };

      this.lineChart.setOption(option);
    },

    // 处理窗口大小变化
    handleResize() {
      if (this.lineChart) {
        this.lineChart.resize();
      }
    }
  }
}
</script>
<style scoped lang="less">
// 引入通用指标样式
@import '@/assets/css/common-indicator.less';

.indicator-container {

  .indicator-content {
    .text-box {
      width: 400px;
    }

    .chart-box {
      display: flex;
      flex-direction: row;

      .triangle-chart {
        width: 300px;
        height: 100%;
      }

      .line-chart-item {
        flex: 1;
        height: 100%;
      }
    }
  }


}
</style>
